import * as v from '@badrap/valita'
import { createStorageCategory } from 'src/storage'

const createStorage = createStorageCategory('session', 'SETUP_SSO')

export const savedConnectUrl = createStorage('connectUrl', v.string())
export const savedInstanceId = createStorage('instanceId', v.string())
export const savedAccountId = createStorage('accountId', v.string())
export const savedInstanceArn = createStorage('instanceArn', v.string())
export const savedArn = createStorage('arn', v.string())

export const savedLoginUrl = createStorage('loginUrl', v.string())
export const savedPrincipalArn = createStorage('principalArn', v.string())
export const savedRegion = createStorage('region', v.string())
export const savedRoleArn = createStorage('roleArn', v.string())

export const savedIdPid = createStorage('idPid', v.string())
export const savedSpid = createStorage('spid', v.string())
